const replaceVariables = original => {
  if (!original) {
    return original
  }

  const replacementRegex = /%%(.*?)%%/g

  return original.replace(replacementRegex, (matched, p1) => {
    return dynamicValues[p1] || matched
  })
}

export { replaceVariables }
